import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

export const Heading = styled.div`
  color: #0f75bf;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.04em;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 56px;
    line-height: 56px;
  }
`;
